import React from 'react';

export const FloatingLogo: React.FC = () => {
  return (
    <div className="fixed left-4 md:left-6 lg:left-8 top-4 z-[9999] pointer-events-auto">
      <a href="#home" className="block">
        <img
          src="/images/logo-wd.svg"
          alt="Erohome"
          className="w-32 md:w-48 lg:w-56 object-contain drop-shadow-xl"
        />
      </a>
    </div>
  );
};

export default FloatingLogo;
